"use client";

import { useEffect } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error("Global Error Caught:", error);
    }, [error]);

    return (
        <html>
            <body style={{
                margin: 0,
                padding: 0,
                background: '#0B0E14',
                color: 'white',
                fontFamily: 'system-ui, sans-serif',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh'
            }}>
                <div style={{ textAlign: 'center', maxWidth: '500px', padding: '24px' }}>
                    <AlertTriangle size={64} color="#ef4444" style={{ marginBottom: '24px' }} />
                    <h1 style={{ fontSize: '2rem', marginBottom: '16px' }}>System Unavailable</h1>
                    <p style={{ color: '#94a3b8', lineHeight: '1.6', marginBottom: '32px' }}>
                        The application failed to start securely. This is likely due to an
                        <strong> SSL Configuration Error</strong> or <strong>Missing API Keys</strong>.
                    </p>

                    <div style={{ background: 'rgba(255,255,255,0.05)', padding: '16px', borderRadius: '8px', marginBottom: '32px', textAlign: 'left' }}>
                        <div style={{ fontSize: '0.8rem', color: '#64748b' }}>Technical Details:</div>
                        <code style={{ fontSize: '0.9rem', color: '#ef4444', display: 'block', marginTop: '8px' }}>
                            {error.message || "Unknown Application Crash"}
                        </code>
                    </div>

                    <button
                        onClick={() => reset()}
                        style={{
                            background: '#6366f1',
                            color: 'white',
                            border: 'none',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        <RefreshCw size={18} /> Try Again
                    </button>
                </div>
            </body>
        </html>
    );
}
